import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getSupplierDropdownList = createApi(`SupplierDropdownListSlice`,"GET");

const SupplierDropdownListSlice = createSlice({
  name: 'SupplierDropdownListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupplierDropdownList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSupplierDropdownList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSupplierDropdownList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SupplierDropdownListSlice.reducer;